import { Tabs as ExpoRouterTabs } from 'expo-router'
import type { ComponentProps, ReactNode } from 'react'

import { mergePageTypeScreenOptions, usePageTypeNavigator } from '@/src/general/hooks/usePageTypeNavigator'

type TExpoTabsProps = ComponentProps<typeof ExpoRouterTabs>

/**
 * expo-router Tabs with page-type style baked in (opaque sceneStyle + screenLayout).
 */
const PageTypeTabsRoot = ({ screenLayout, screenOptions, ...props }: TExpoTabsProps): ReactNode => {
  const { pageBackgroundColor, composeScreenLayout } = usePageTypeNavigator()

  return (
    <ExpoRouterTabs
      {...props}
      screenLayout={composeScreenLayout(screenLayout)}
      screenOptions={mergePageTypeScreenOptions('sceneStyle', pageBackgroundColor, screenOptions)}
    />
  )
}

export const Tabs = Object.assign(PageTypeTabsRoot, {
  Screen: ExpoRouterTabs.Screen,
  Protected: ExpoRouterTabs.Protected,
})
